import React, {FC} from 'react';
import DynamicAsset from 'components/DynamicAsset';
import {Link} from 'gatsby';

import * as styles from './styles.module.scss';

export type CardsSliderItemProps = {
	imageSrc: string;
	title: string;
	subTitle: string;
	link: string;
}

const CardsSliderItem: FC<CardsSliderItemProps> = ({
	imageSrc,
	title,
	subTitle,
	link,
}) => {
	return (
		<Link className={styles.item} to={link}>
			<DynamicAsset
				className={styles.image}
				imageSrc={imageSrc}
				alt={title}
			/>
			<div className={styles.text}>
				<div className={styles.title}>
					{title}
				</div>
				<div className={styles.subTitle}>
					{subTitle}
				</div>
			</div>
		</Link>
	);
};

export default CardsSliderItem;
